import { getTimezoneObject } from "@simplyk/common";
import { DateTime } from "luxon";

function isDateDst(inputDate: Date, timezone: string) {
  // https://stackoverflow.com/a/30280636/9313537
  // We use luxon to be able to manipulate date at the specified timezone (javascript only use the browser timezone)
  const date = DateTime.fromJSDate(inputDate, { zone: timezone });
  const january = new Date(inputDate.getFullYear(), 0, 1);
  const januaryOffset = DateTime.fromJSDate(january, { zone: timezone }).offset;
  const july = new Date(inputDate.getFullYear(), 6, 1);
  const julyOffset = DateTime.fromJSDate(july, { zone: timezone }).offset;

  return Math.max(januaryOffset, julyOffset) === date.offset; // We use === instead of !== from StackOverflow because using luxon offset, the offset are the negative amount of js getTimezoneOffset()
}

// The date chosen by the user, is set to UTC using the timezone the user has selected
export const setDateToUtc = (date: Date, timeZone: string): Date => {
  const isDst = isDateDst(date, timeZone);
  const zone = getTimezoneObject(timeZone);
  const timezoneOffset = isDst ? zone?.dstOffset || 0 : zone?.utcOffset || 0;

  const browserTimeZoneOffset = date.getTimezoneOffset();

  return new Date(date?.getTime() - (timezoneOffset + browserTimeZoneOffset) * 60 * 1000);
};

// The utc date saved is converted to the timezone the user has selected
export const setDateFromUtc = (date: Date, timeZone: string): Date => {
  const isDst = isDateDst(date, timeZone);
  const zone = getTimezoneObject(timeZone);
  const timezoneOffset = isDst ? zone?.dstOffset || 0 : zone?.utcOffset || 0;

  const browserTimeZoneOffset = date.getTimezoneOffset();

  return new Date(date?.getTime() + (timezoneOffset + browserTimeZoneOffset) * 60 * 1000);
};
